import React from 'react';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import { StyledAppend } from './index.style';

/** "+ Thêm khối / video / nhạc nền" affordance at the end of a lane. */
const AppendButton = ({ label, onClick, disabled = false }) => (
  <StyledAppend type="button" onClick={onClick} disabled={disabled}>
    <AddRoundedIcon />
    {label}
  </StyledAppend>
);

export default AppendButton;
